import { render, staticRenderFns } from "./Seteaza_agent.vue?vue&type=template&id=616e4b92&scoped=true&"
import script from "./Seteaza_agent.vue?vue&type=script&lang=js&"
export * from "./Seteaza_agent.vue?vue&type=script&lang=js&"
import style0 from "./Seteaza_agent.vue?vue&type=style&index=0&id=616e4b92&prod&lang=less&scoped=true&"
import style1 from "./Seteaza_agent.vue?vue&type=style&index=1&id=616e4b92&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e4b92",
  null
  
)

export default component.exports